import React from 'react';
import { Instagram, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal pt-16 pb-8 border-t border-charcoal-soft" data-id="element-61">
      <div className="container mx-auto px-4" data-id="element-62">
        <div className="flex flex-col items-center text-center" data-id="element-63">
          <a href="#" className="flex items-baseline gap-1 mb-6" data-id="element-64">
            <span className="text-2xl md:text-3xl font-extrabold tracking-tight text-white font-heading" data-id="element-65">
              EPIC PAVERS
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-teal block" data-id="element-66"></span>
          </a>

          <p className="text-sand max-w-md mb-8" data-id="element-67">
            Premium hardscaping and outdoor living transformations serving Las
            Vegas, North Las Vegas, and Henderson.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-6 mb-10" data-id="element-68">
            <a href="tel:7027556539" className="flex items-center gap-2 text-white hover:text-teal transition-colors font-bold text-lg" data-id="element-69">
              <Phone className="w-5 h-5 text-teal" data-id="element-70" />
              702-755-6539
            </a>
            <div className="hidden sm:block w-px h-6 bg-charcoal-soft" data-id="element-71"></div>
            <a href="#" className="flex items-center gap-2 text-white hover:text-teal transition-colors font-bold text-lg" data-id="element-72">
              <Instagram className="w-5 h-5 text-teal" data-id="element-73" />
              @epicpavers
            </a>
          </div>

          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-12" data-id="element-74">
            <a href="#services" className="text-sand hover:text-teal transition-colors text-sm font-medium" data-id="element-75">
              Services
            </a>
            <a href="#work" className="text-sand hover:text-teal transition-colors text-sm font-medium" data-id="element-76">
              Our Work
            </a>
            <a href="#process" className="text-sand hover:text-teal transition-colors text-sm font-medium" data-id="element-77">
              Process
            </a>
            <a href="#contact" className="text-sand hover:text-teal transition-colors text-sm font-medium" data-id="element-78">
              Free Estimate
            </a>
          </nav>

          <div className="w-full h-px bg-charcoal-soft mb-8" data-id="element-79"></div>

          <div className="flex flex-col md:flex-row items-center justify-between w-full gap-4" data-id="element-80">
            <p className="text-charcoal-soft text-sm font-medium text-sand/50" data-id="element-81">
              &copy; {new Date().getFullYear()} Epic Pavers. All rights
              reserved.
            </p>
            <p className="text-charcoal-soft text-sm font-medium text-sand/30" data-id="element-82">
              Managed by LetLois
            </p>
          </div>
        </div>
      </div>
    </footer>;
}